import React from "react";
import { Box } from "@mui/material";
import DebtorRegistry from "../../components/DebtorRegistry";

function DataManagement() {
  return (
    <Box sx={{ p: 3 }}>
      <DebtorRegistry />
    </Box>
  );
}

export default DataManagement;
